import { MutableRefObject, useEffect, useRef, useState } from 'react';

interface IntersectionObserverArgs {
  threshold?: number | number[];
  root?: Element | null;
  rootMargin?: string;
}

const useIntersectionObserver = ({
  threshold = 0.1,
  root = null,
  rootMargin = '0%',
}: IntersectionObserverArgs): [MutableRefObject<null>, boolean] => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasBeenVisible, setHasBeenVisible] = useState(false);
  const ref = useRef<null>(null);

  useEffect(() => {
    const currentRef = ref.current;

    if (!currentRef) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasBeenVisible) {
          setIsVisible(true);
          setHasBeenVisible(true);
        }
      },
      {
        threshold,
        root,
        rootMargin,
      },
    );

    observer.observe(currentRef);

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [threshold, root, rootMargin, hasBeenVisible]);

  return [ref, isVisible];
};

export default useIntersectionObserver;
